import {Moment} from 'moment';

export interface IWaterLevelCardData {
  telegramDate:Moment;
  previousDate:Moment;
  waterLevelAtEight:number;
  waterLevelAtTwenty:number;
  previousWaterLevelAtTwenty:number;
  previousWaterLevelAtEight?:number;
  averageWaterLevel:number;
  waterLevelTrend:number;
  validWaterTrend:boolean;
}

export default class OperationalInputWaterLevelCardController {
  /**
   * Displayed water level data.
   */
  waterLevelData:IWaterLevelCardData;
}



/** WEBPACK FOOTER **
 ** ./app/operational/input/kn15-telegram/water-level-card.controller.ts
 **/